import * as Sentry from "@sentry/react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import { CURRENT_LOAN_APPLICATION_STORE_KEY } from "@krea/customer-features/store/queryClient";
import { useGetUserData } from "@krea/customer-features/store/user/hooks/queries/useGetUserData";
import {
  IHttpRestResponse,
  INoContentResponse,
} from "@krea/shared/types/response";

import { submitApplication } from "@/services/api/loan-application/actions";

export const useWithoutAdvice = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { data } = useGetUserData();
  const loanApplicationID = data?.currentLoanApplication?.id;

  return useMutation<INoContentResponse, IHttpRestResponse>({
    mutationFn: async () => {
      await submitApplication();
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [CURRENT_LOAN_APPLICATION_STORE_KEY, loanApplicationID],
      });
      navigate("/");
    },
    onError: (err) => {
      console.error("Advice error", err);
      Sentry.captureException(err);
    },
  });
};
